import React, { Component } from "react";
import {
  withStyles,
  MenuItem,
  Button,
  Menu,
  CircularProgress,
} from "@material-ui/core";
import { __trackStatus } from "../../definition/status";
import {
  __getTrackStatusByID,
} from "../../utils/utils";

import { connect } from "react-redux";
import { loadRuntime } from "../../../redux/actions/ClearanceRuntimeActions";
// import trackFields from "../../../_module/definition/trackFields";
import { AiOutlineClear } from "react-icons/ai";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import { styles } from "./Styles.css";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import LockIcon from "@material-ui/icons/Lock";
import {
  postItem,
  refreshitems,
  openWizard,
  getCFContent,
  loadcfWithClerance,
  getCFTrackMetadata,
  refreshEdit,
  getCFTrackEpisodes,
  refreshCF,
  getCFAddTracksToEpisodes,
  closePopupOnRefresh,
  setBlockRefresh,
} from "../../../redux/actions/MlLicFormContentActions";

import {
  postItem as postItemCfTrack,
  refreshItems as refreshItemsTrack,
} from "../../../redux/actions/MlLicTrackActions";

import { withRouter } from "react-router";
import ClearanceOverride from "./ClearanceOverride";
import { canEditClearanceForms } from "util/CommonFunc";
import clsx from "clsx";
import { MdAddToQueue } from "react-icons/md";
import AddTracksToEpisodes from "modules/ml-licensing/clearance-form/AddTracksToEpisodes";


class ClearanceMenu extends Component {
  canRunCFWizard = false;
  canOverrideClearance = false;

  constructor(props) {
    super();

    this.state = {
      anchorEl: null,
      loading: false,
      errors: null,
      addToEpisodesDialogOpen: false,
      loadingTrackMeta: false,
      refertolicencingDialogOpen: false,
    };

    const { focusTrack, fromCFTrack, fromCfBy,
      orgRuntime: {
        runtime: {
          _mlLicensing,
          _mlLicensingOverideRestrictions,
          _mlLicensingOverideRestrictionsOptions,
          _trackFields,
          _trackMusicOrigins
        }
      },
    } = props;

    this.canRunCFWizard = canEditClearanceForms(fromCfBy);

    this.canOverrideClearance = _PermittedContent([_mlLicensing, _mlLicensingOverideRestrictions,], _mlLicensingOverideRestrictionsOptions.yes.id) === _mlLicensingOverideRestrictionsOptions.yes.id ? true : false;

    this.canCopyLive =
      (fromCFTrack
        ? focusTrack.trackDetails[_trackFields.musicOrigin.id]
        : focusTrack.trackDetails[_trackFields.musicOrigin.id]) ===
      _trackMusicOrigins.origincommercial.val;
  }

  getCF = async (cfid) => {
    this.setState({ loading: true, errors: null });
    return getCFContent(cfid, (data) => {
      return data;
    });
  };

  handleMenuClick = (event) => {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = (event) => {
    if (event) event.stopPropagation();
    this.setState({ anchorEl: null });
  };

  componentDidMount() {
    const {
      runtime: { loading, errors, runtime },
      loadRuntime,
    } = this.props;

    if (!loading && !runtime && !errors) {
      loadRuntime(null);
    }
  }

  getStatuses = () => {
    const {
      runtime: { loading, runtime },
    } = this.props;

    if (loading) return [];
    let lreturn = [];
    (runtime?._statuses || []).map((v) => {
      lreturn.push({
        id: v.id,
        label: v.name,
      });
    });

    return lreturn;
  };

  getStatus = (id) => {
    const {
      runtime: { loading, runtime },
    } = this.props;
    if (loading) return { name: "", color: "" };
    return __getTrackStatusByID(id, runtime?._statuses || []);
  };

  handleClose = (event) => {
    const { openWizard } = this.props;
    openWizard({ ids: [], copyLive: false });
  };

  _openWiz(event, id = null, cfid = null, copyLive = false) {
    event.stopPropagation();

    const { focusTrack, fromCFTrack, openWizard, propogateClose, runtime: { runtime }, } = this.props;
    let  addToEpisodeData =  null;

    let selectionLimits = runtime?._config?.CF_ADD_EPISODE_LIMITS?.find(epl => epl.type === focusTrack.clearanceFormClearanceFormType) || null;
    if(
      selectionLimits 
      && selectionLimits.origins?.includes(focusTrack.origin)
      && focusTrack?.trackEpisodes?.length
      && focusTrack?.clearancestatus
      && runtime?._config?.SERIES_MASTER_ALLOWED_STATUSES.includes(+focusTrack.clearancestatus) 
    ){
      addToEpisodeData = {
        selectedEpisodes: focusTrack?.trackEpisodes,
        addedList: [],
        removedList: [],
        isMaster: true,
        masterFormId: focusTrack.clearanceFormId,
        clearanceFormId: focusTrack.clearanceFormId,
        clearanceFormType: focusTrack.clearanceFormClearanceFormType,
        confirmed: [focusTrack ],
        trackClearance: null,
        tracks: [focusTrack?.trackDetails?.id],
      };
    }

    if (!fromCFTrack) {
      this.setState({ anchorEl: null });
      openWizard({ ids: id ? [id] : [], copyLive, ...(addToEpisodeData ? {addToEpisodeData: addToEpisodeData} : {}) });
    } else {
      this.getCF(cfid).then((cf) => {
        if (cf) {
          this.setState({ loading: false, errors: null, anchorEl: null });
          if (propogateClose) propogateClose();

          const { loadcfWithClerance } = this.props;
          loadcfWithClerance(
            { ...cf, wizard: { ids: id ? [id] : [], copyLive } },
            () => {
              this.props.history.push("/mllicensingforms/" + cf.id);
            }
          );
        } else {
          this.setState({ loading: false, errors: { e: "Error" } });
        }
      });
    }
  }

  loadClearanceTrackMetadata = (trackIds) => {
    const { getCFTrackMetadata } = this.props;
    if(!this.state.loadingTrackMeta){
      this.setState({
        loadingTrackMeta: true
      })
      return new Promise((resolve, reject) => {
        getCFTrackMetadata(trackIds, (data, error) => {
          this.setState({
            loadingTrackMeta: false
          })
          if (data) {
            resolve(data);
          }
        });
      })
    }
  }

  onClearTrack = async (event, allEpisodes = false, allBackgroundUse = false) => {
    const { focusTrack, fromCFTrack, refreshEdit, mllicformcontent: { editing }, } = this.props;

    let nediting = {
      ...editing,
      clearance: {
        ...editing.clearance,
        tLookup: editing.clearance?.tLookup?.filter(t=> t.id !== focusTrack?.trackDetails?.id) || []
      }
    }

    refreshEdit({
      ...nediting,
      allEpisodes: allEpisodes,
      allBackgroundUse: allBackgroundUse
    });

    if (focusTrack?.trackDetails?.id) {
      await this.loadClearanceTrackMetadata([focusTrack.trackDetails.id]);
    }

    this._openWiz(
      event,
      fromCFTrack ? focusTrack.trackDetails.id : focusTrack.trackDetails.id,
      fromCFTrack ? focusTrack.clearanceFormId : null
    );
  };

  onLivePerformance = async (event) => {
    const { focusTrack, fromCFTrack } = this.props;
    if (focusTrack?.trackDetails?.id) {
      await this.loadClearanceTrackMetadata([focusTrack.trackDetails.id]);
    }
    this._openWiz(
      event,
      fromCFTrack ? focusTrack.trackDetails.id : focusTrack.trackDetails.id,
      fromCFTrack ? focusTrack.clearanceFormId : null,
      true
    );
  };

  showUserOverride = (event) => {
    const {
       runtime:{runtime},  
       focusTrack: rowData,
       mllicformcontent: { editing, },
      } = this.props;

    if(runtime?._config?.CF_REFER_TO_LIC_RULES?.length){
      let trackId = rowData?.trackDetails?.id;
      let ruleID = rowData?.ruleID ?? ((trackId && editing?.clearance?.commits && editing?.clearance?.commits[trackId]?.rules?.length) ? editing?.clearance?.commits[trackId].rules[0]?.ruleid : null);
     
      if(rowData?.clearancestatus && ruleID && runtime?._config?.CF_REFER_TO_LIC_RULES.findIndex(e => (+e.status === +rowData.clearancestatus && +e.ruleid === +ruleID && (e.cfType ?? []).includes(editing?.clearanceFormType) )) > -1){
        return true;
      }
    }

    return false;
  }

  render() {
    const { anchorEl, loading, errors, addToEpisodesDialogOpen } = this.state;
    const {
      classes,
      focusTrack: rowData,
      mllicformcontent: {
        posting: { busy },
        editing,
        episodeList
      },
      runtime: { runtime },
      fromCFTrack,
      refreshDownloadLink,
      isSeriesTrack,
      isMasterForm,
      orgRuntime: {
        runtime: {
          _trackMusicOrigins
        }
      },
      disableMenu, 
      refreshEdit,
      closePopupOnRefresh,
      setBlockRefresh,
    } = this.props;

    return (
      <>
        {addToEpisodesDialogOpen &&
          <AddTracksToEpisodes
            open={addToEpisodesDialogOpen}
            onClose={(refresh = false, updatedCf = null) => {
              this.setState({ addToEpisodesDialogOpen: false });
              this.handleMenuClose();
              if(refresh && updatedCf){
                refreshEdit({
                  ...updatedCf,
                });
              }
            }}
            classes={classes}
            cf={editing}
            track={rowData}
            key={`addTracksToEpisodes-${rowData.id}`}
            props={{
              ...this.props,
              data: { //remove this if master form needded to added again to the popup
                ...this.props.mllicformcontent,
                episodeList: this.props.mllicformcontent?.episodeList?.length > 0 ? this.props.mllicformcontent?.episodeList.filter(e => !e.master) : []
              }
            }}
          />
        }
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={this.handleMenuClick}
          className={clsx(classes.clearanceDropMenu, "clearanceDropDownMenu")}
          disabled={
            (editing && runtime && runtime?._config && editing[runtime?._config?.MIGRATED_FLAG]) 
            || (rowData && (rowData[runtime?._config?.MIGRATED_FLAG] ))
            || isSeriesTrack 
            || disableMenu 
            || (!this.canRunCFWizard)
            || false}
        >
          {rowData.clearancestatus &&
            rowData.clearancestatus !== __trackStatus.clearMe.id ? (
            <>
              <span
                class="clearanceValueLabel"
                style={{
                  color: this.getStatus(rowData.clearancestatus).color,
                }}
              >
                <div
                  style={{
                    background: this.getStatus(rowData.clearancestatus).color,
                  }}
                ></div>
                {this.getStatus(rowData.clearancestatus).name}
              </span>
              <ArrowDropDownIcon />
            </>
          ) : (
            <span className={classes.clearMe} title="Clear Me">
              Clear Me <ArrowDropDownIcon />
            </span>
          )}
        </Button>

        {anchorEl && (this.canRunCFWizard || !fromCFTrack) && (
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            anchorOrigin={{
              horizontal: "left",
              vertical: "bottom",
            }}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={this.handleMenuClose}
          >
                {/* {this.canRunCFWizard && isMasterForm &&
                  <MenuItem
                    disabled={loading || !this.canRunCFWizard || isSeriesTrack}
                    onClick={(e) => this.onClearTrack(e, true, (rowData.origin === _trackMusicOrigins.origincommercial.val))}
                    autoFocus
                  >
                    <AiOutlineClear className={classes.clearanceIcon} />
                    {
                      !isNaN(rowData.clearancestatus) && rowData.clearancestatus && +rowData.clearancestatus !== +__trackStatus.clearMe.id
                        ? ((rowData.origin === _trackMusicOrigins.origincommercial.val) ? "Re-clear ( All Episodes, BACKGROUND use only )" : "Re-clear (All Episodes)")
                        : ((rowData.origin === _trackMusicOrigins.origincommercial.val) ? "Clear ( All Episodes, BACKGROUND use only )" : "Clear (All Episodes)")}
                    {" "}
                    {!this.canRunCFWizard && <LockIcon />}
                    {loading && <CircularProgress className={classes.insideLoader} />}
                    {errors && <span>Error</span>}
                  </MenuItem>
                } */}
                {this.canRunCFWizard && <MenuItem
                  disabled={loading || this.state.loadingTrackMeta || !this.canRunCFWizard || isSeriesTrack || rowData?.hybrid}
                  onClick={(e) => {
                    if(editing?.clearanceFormType === runtime?._config?.CLEARANCE_FORM_TYPE?.PROGRAMMING && editing?.programmeType === runtime?._config?.PROGRAMME_TYPES?.SERIES && (+rowData.clearancestatus === +__trackStatus.clearMe.id) && episodeList?.length > 1){
                      this.setState({ addToEpisodesDialogOpen: true });
                    }else{
                      this.onClearTrack(e, false)
                    }
                  }}
                  autoFocus
                >

                  <AiOutlineClear className={classes.clearanceIcon} />
                  {
                    !isNaN(rowData.clearancestatus) && rowData.clearancestatus && +rowData.clearancestatus !== +__trackStatus.clearMe.id
                      ? "Re-clear" : "Clear"}
                  {" "}
                  {!this.canRunCFWizard && <LockIcon />}
                  {(loading || this.state.loadingTrackMeta) && <CircularProgress className={classes.insideLoader} />}
                  {errors && <span>Error</span>}
                </MenuItem>}

                {/* commented live copy cf as per the ML20-3990  */}
                {/* {this.canRunCFWizard && <MenuItem
                  disabled={!this.canCopyLive}
                  onClick={this.onLivePerformance}
                >
                <FiMusic  className={classes.clearanceIcon}/> Run Clearance (Live Version){" "}
                  {!this.canRunCFWizard && <LockIcon />}
                </MenuItem>} */}

            {!fromCFTrack && !isNaN(rowData.clearancestatus) && +rowData.clearancestatus !== +__trackStatus.clearMe.id && (
              <ClearanceOverride
                inMenu
                trackData={rowData}
                isMasterForm={isMasterForm}
                classes={classes}
                hideCount
                isSeriesTrack={isSeriesTrack}
                selectedItems={[rowData.id]}
                onClose={() => {
                  this.handleMenuClose();
                }}
                canAutoFocus={!this.canRunCFWizard && this.canOverrideClearance}
                refreshDownloadLink={refreshDownloadLink ? refreshDownloadLink : false}
                key={`clearanceOverride-${rowData.id}`}
                closePopupOnRefresh = {()=>closePopupOnRefresh()}
                setBlockRefresh = {(block, shouldSearch)=>{setBlockRefresh(block, shouldSearch)}}
                disabled={rowData?.hybrid || false}
              />
            )}

              {this.showUserOverride() && <ClearanceOverride
                inMenu
                userOverride
                trackData={rowData}
                isMasterForm={isMasterForm}
                classes={classes}
                hideCount
                isSeriesTrack={isSeriesTrack}
                selectedItems={[rowData.id]}
                onClose={() => {
                  this.handleMenuClose();
                }}
                canAutoFocus={!this.canRunCFWizard && this.canOverrideClearance}
                refreshDownloadLink={refreshDownloadLink ? refreshDownloadLink : false}
                key={`userOverride-${rowData.id}`}
                closePopupOnRefresh = {()=>closePopupOnRefresh()}
                setBlockRefresh = {(block, shouldSearch)=>{setBlockRefresh(block, shouldSearch)}}
                disabled={rowData?.hybrid || false}
              />}

            {this.canRunCFWizard && (editing?.programmeType === runtime?._config?.PROGRAMME_TYPES?.SERIES) &&
              <MenuItem
                disabled={
                  busy ? true : (!editing.id ? true : false)
                    || (runtime && runtime._config && editing[runtime._config.MIGRATED_FLAG])
                    || (episodeList?.length <= 1)
                    || (runtime?._config?.SERIES_MASTER_ALLOWED_STATUSES?.length && !runtime?._config?.SERIES_MASTER_ALLOWED_STATUSES.includes(+rowData.clearancestatus))
                    || false}
                aria-label="Add / Remove Tracks - Episode(s)"
                onClick={(e) => {
                  this.setState({ addToEpisodesDialogOpen: true });
                }}
              >
                <MdAddToQueue className={classes.clearanceIcon} /> Add / Remove Tracks - Episode(s)
              </MenuItem>}
          </Menu>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  runtime: state.clearanceRuntime,
  mllicformcontent: state.mllicformcontent,
  mllictrack: state.mllictrack,
  user: state.user,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  loadRuntime,
  postItem,
  refreshitems,
  openWizard,
  postItemCfTrack,
  refreshItemsTrack,
  loadcfWithClerance,
  getCFTrackMetadata,
  refreshEdit,
  getCFTrackEpisodes,
  refreshCF,
  getCFAddTracksToEpisodes,
  closePopupOnRefresh,
  setBlockRefresh,
})(withStyles(styles)(withRouter(ClearanceMenu)));
